import loadCookie from './cookie';
import { ONE_MONTH_SEC, unixNowSec } from './dateTime';

const KEY = 'signed-up';

/**
 * Determines if someone was already signed up on this machine.
 *
 * The twin `trackSomeoneWasSignedUp` function will read the current user cookie
 * and, if present, store a local storage key containing an expiry of 1 month.
 *
 * Effectively, this function uses that data to determine if a person was signed
 * in on the current machine (browser), within the last month, even if they are
 * currently signed out.
 *
 * @returns {Boolean} Flag indicating if someone was signed in on this machine
 * within the last 30 days.
 */
export const someoneWasSignedUpOnThisMachineInLast30Days = (): boolean => {
  const strValue = localStorage.getItem(KEY);
  if (strValue === null) {
    return false;
  }

  const intValue = parseInt(strValue);
  if (isNaN(intValue)) {
    return false;
  }

  const now = unixNowSec();
  return now <= intValue;
};

/**
 * Reads the `current_user` cookie set by the backend and, if present, sets a
 * local storage key containing an expiry time in seconds.
 *
 * This allows us to track if someone was signed in on this machine within the
 * last 30 days.
 */
export const trackSomeoneWasSignedUpInLast30Days = (): void => {
  if (localStorage.getItem(KEY)) {
    return;
  }
  if (!loadCookie('current_user')) {
    return;
  }

  localStorage.setItem(KEY, (unixNowSec() + ONE_MONTH_SEC).toString());
};
